import { render, staticRenderFns } from "./GetCustomerPaymentsHistorySubComponent.vue?vue&type=template&id=7841f0e3&scoped=true&"
import script from "./GetCustomerPaymentsHistorySubComponent.vue?vue&type=script&lang=js&"
export * from "./GetCustomerPaymentsHistorySubComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7841f0e3",
  null
  
)

export default component.exports